import PropTypes from 'prop-types'

const Highlight = ({ match, string }) => {
  const html = string.replaceAll(match, `<em class="fc_emph">${match}</em>`)
  return <span dangerouslySetInnerHTML={{ __html: html }} />
}
Highlight.propTypes = {
  match: PropTypes.string,
  string: PropTypes.string,
}
export default Highlight
